import React from "react";
import { Routes, Route } from 'react-router-dom';

import PublisherDashboard from './../Pages/Publisher/Dashboard';

import PublisherLeads from './../Pages/Publisher/Leads/Lead';
import PublisherLeadFilter from './../Pages/Publisher/Leads/LeadFilter';

//import PublisherProfile from './../Pages/Publisher/Profile';

//import NotFound from './../Pages/NotFound';

const Publisher = [
    {
        path: "publisher/dashboard", 
        element: <PublisherDashboard />,
    },
    {
        path: "publisher/leads", 
        element: <PublisherLeads />,
    },
    {
        path: "publisher/lead/:filtertype", 
        element: <PublisherLeadFilter />,
    }
];



export default Publisher;